/**
 * Resolves an output filename by substituting `{value}` in the template with the supplied
 * value, then appending the original file's extension.
 *
 * The template must NOT include a file extension — the extension is always derived from the
 * original filename and appended by this function.
 *
 * @example
 * resolveOutputFilename("report_cu_{value}", "1", "data.csv")  // → "report_cu_1.csv"
 * resolveOutputFilename("report_{value}_cu", "rp", "data.csv") // → "report_rp_cu.csv"
 */
export const resolveOutputFilename = (template: string, value: string, originalFilename: string): string => {
  const dot = originalFilename.lastIndexOf('.');
  const ext = dot === -1 ? '' : originalFilename.slice(dot + 1);
  const base = template.replace('{value}', value);

  return ext ? `${base}.${ext}` : base;
};
